export default {
  state: {
    processInstanceId: "",
    businessId: "",
    businessName: "",
    processKey: "",
    tableName:"",
    taskId: "",
    scheduleCount: 0,
    historyKey: "",
    outObjectJump: [],
    outObjectJumpComments: '',
    modelId: ''
  },
  getters: {
    waitToAll(state) {
      return state.scheduleCount * 1 + state.waitToReadCount * 1
    }
  },
  mutations: {
    setProcessInstanceId(state, processInstanceId) {
      state.processInstanceId = processInstanceId
    },
    setProcessKey(state, processKey) {
      state.processKey = processKey
    },
    setTableName(state, tableName) {
      state.tableName = tableName
    },
    setTaskId(state, taskId) {
      state.taskId = taskId
    },
    setBusinessId(state, businessId) {
      state.businessId = businessId
    },
    setBusinessName(state, businessName) {
      state.businessName = businessName
    },
    setScheduleCount(state, scheduleCount) {
      state.scheduleCount = scheduleCount
    },
    setHistoryKey(state, historyKey) {
      state.historyKey = historyKey
    },
    setOutObjectJump(state, outObjectJump) {
      state.outObjectJump = outObjectJump
    },
    setOutObjectJumpComments(state, outObjectJumpComments) {
      state.outObjectJumpComments = outObjectJumpComments
    },
    setModelId(state, modelId) {
      state.modelId = modelId
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/process.js